var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 46.875H34.375V6.25H46.875V46.875ZM37.5 43.75H43.75V9.375H37.5V43.75ZM31.25 46.875H18.75V18.75H31.25V46.875ZM21.875 43.75H28.125V21.875H21.875V43.75ZM15.625 46.875H3.125V28.125H15.625V46.875Z",
    fill: "#498CCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.eb811e9f8014bfa45f2d92966a213475.svg";
export { ForwardRef as ReactComponent };